import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiContentService } from '../../api/api-content.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {Location} from '@angular/common';

@Component({
  selector: 'app-regispay',
  templateUrl: './regispay.component.html',
  styleUrls: ['./regispay.component.css']
})
export class RegispayComponent implements OnInit {

  constructor(
    private route:ActivatedRoute,
		public contentService:ApiContentService,
    private fb: FormBuilder,  
    private router: Router,
    private _location: Location
  ) { }

  // registerForm: FormGroup;
  submitted = false;
  refid = '';
  loadingIcon = {
    invalid: false
  };
  regis:any = [];
  fileData: File = null;
  previewUrl:any = null;
  fileUploadProgress: string = null;
  uploadedFilePath: string = null;
  type_pembayaran: any = [];
  type_tunai: any = [];
  type_credit: any = [];
  prospekindex:any
  lainnya_credit = false
  form_credit = false

  pay:any = {}
  data_bonus:any = []
  data_order: any = []
  data_discount: any = []
  data_bonus_regis: any = []
  data_discount_regis: any = []

  ngOnInit(): void {
    this.prospekindex = this.route.snapshot.params.prospekindex
    this.checkProspek(this.prospekindex);
    this.getPembayaran()
    // this.pay['period_total'] = 1
    // this.getDiscountregis(this.pay['period_total'])
    this.getBonusregis()
    this.getProspeksummary()
  }

  checkProspek(prospekindex:any){
    // console.log(prospekindex);
    const params = {
      'prospekindex' : prospekindex
    }
    this.contentService.checkProspek(params).subscribe((response:any) => {
      if (response.status) {
        this.loadingIcon.invalid = false;

        // this.regis = response.data;
        // this.listProductiptv()

      }else{
        this.loadingIcon.invalid = true;
      }
    });
  }

  // get f(){
  //   return this.registerForm.controls;
  // }

  // checkAccount(accountid:any){
  //   // console.log(accountid);
  //   const params = {
  //     'accountid' : accountid
  //   }
  //   this.rest.checkAccount(params).subscribe((response:any) => {
  //     console.log(this.regis,response.data);
  //     if (response.status) {
  //       this.loadingIcon.invalid = false;

  //       this.regis = response.data;

  //     }else{
  //       this.loadingIcon.invalid = true;
  //     }
  //   });
  // }

  fileProgress(fileInput: any) {
    this.fileData = <File>fileInput.target.files[0];
    this.preview();
  }

  preview() {
    // Show preview 
    var mimeType = this.fileData.type;
    if (mimeType.match(/image\/*/) == null) {
      return;
    }

    var reader = new FileReader();      
    reader.readAsDataURL(this.fileData); 
    reader.onload = (_event) => { 
      this.previewUrl = reader.result; 
    }
  }

  getPembayaran() {
    const params = {
      'type_id' : 1
    }
    this.form_credit = false
    this.lainnya_credit = false
    this.contentService.getPembayaran(params).subscribe((response: any) => {
        // console.log(response)
        this.type_pembayaran = response.data;
      }
    );
  }

  getProspeksummary() {
    const params = {
      'prospekindex' : this.prospekindex
    }

    this.contentService.getProspeksummary(params).subscribe((response: any) => {
        console.log(response)
        this.pay['price_total'] = response.data.price_total;
        this.data_order = response.data.order;
        this.data_bonus = response.data.bonus;
        this.data_discount = response.data.discount;
      }
    );
  }

  getDiscountregis(period_total:any) {
    this.form_credit = false
    this.lainnya_credit = false
    const params = {
      'channel_type' : 2,
      'prospek_id' : this.prospekindex,
      'period_total' : period_total,
    }
    this.contentService.listDiscountregissgs(params).subscribe((response: any) => {
        console.log(response)
        this.data_discount_regis = response.data;
        this.data_discount_regis.forEach((row:any) => {
          row['discount_select'] = false
        });
      }
    );
  }

  getBonusregis() {
    const params = {
      'channel_type' : 2,
      'prospek_id' : this.prospekindex,
    }
    this.contentService.listBonusregissgs(params).subscribe((response: any) => {
        // console.log(response)
        this.data_bonus_regis = response.data;
        this.data_bonus_regis.forEach((row:any) => {
          row['bonus_select'] = false
        });
      }
    );
  }

  clearDiscountregis(ddr:any){
    let params = {}
    params = ddr
    params['prospekindex'] = this.prospekindex

    this.contentService.clearDiscount(params).subscribe((response: any) => {
        console.log(response)
        alert(response.message)
        // this.data_discount = response.data;
        this.getProspeksummary()
      }
    );
  }

  setDiscount(dd:any) {
    this.form_credit = false
    this.lainnya_credit = false
    const params = dd
    params['prospekindex'] = this.prospekindex
    params['channel_type'] = 2

    this.contentService.setDiscount(params).subscribe((response: any) => {
        console.log(response)
        alert(response.message)
        // this.data_discount = response.data;
        this.getProspeksummary()
      }
    );
  }

  clearBonusregis(dbr:any){
    let params = {}
    params = dbr
    params['prospekindex'] = this.prospekindex

    this.contentService.clearBonus(params).subscribe((response: any) => {
        console.log(response)
        alert(response.message)
        // this.data_discount = response.data;
        this.getProspeksummary()
      }
    );
  }

  setBonus(db:any) {
    this.form_credit = false
    this.lainnya_credit = false
    const params = db
    params['prospekindex'] = this.prospekindex
    params['channel_type'] = 2

    this.contentService.setBonus(params).subscribe((response: any) => {
        console.log(response)
        alert(response.message)
        // this.data_discount = response.data;
        this.getProspeksummary()
      }
    );
  }

  setPaymentmethod() {
    const params = this.pay
    params['prospekindex'] = this.prospekindex

    this.contentService.setPaymentmethod(params).subscribe((response: any) => {
        console.log(response)
        // this.data_bonus = response.data;
        if ( response.status == true ) {
          alert(response.message)
          alert('Terimakasih Sudah melengkapi data\nKami akan memprosesnya.')
          this.router.navigate(['regis']);
          
        } else {
          alert(response.message)
        }
      }
    );
  }

  getBayar(e:any) {
    this.form_credit = false
    this.lainnya_credit = false
    const params = {
      'type_id' : e.target.value
    }
    this.contentService.getPembayaran(params).subscribe((response: any) => {
        // console.log(response)
        this.type_tunai = response.data;
      }
    );
  }

  getCredit(e:any) {

    this.form_credit = true
    console.log(e.target.value)
    if (e.target.value == 'Lainnya') {
      this.lainnya_credit = true
    } else {
      this.lainnya_credit = false
    }
  }

  delAlacarte(){

  }

  onSubmit(){
    this.submitted = true;

    const id = this.regis.accountidreferral
    console.log(id);
    
    // if (this.registerForm.invalid) {
    //   return;
    // }

    this.router.navigate(['regispay/', id]);
  }

  backClicked() {
    this.router.navigate(['regis3/', this.prospekindex]);
  }

  onReset(){
    this.submitted = false;
    // this.registerForm.reset();
  }

}
